import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const documentSignatureReminderTemplates = [
  {
    id: '-100001',
    language: Language.EN,
    subject: 'Reminder: document(s) to be signed',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear tenant,</p>
        <p></p>
        <p>Concerns: invitation to sign document(s) related to the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>We kindly remind you to sign some document(s) by connecting to your account:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Comment: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-100002',
    language: Language.FR,
    subject: 'Rappel: document(s) à signer',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère locataire,</p>
        <p></p>
        <p>Concerne: rappel de l'invitation à signer le(s) document(s) concernant le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous vous invitons à signer le(s) document(s) en vous connectant à votre compte utilisateur:</p>
        <ul>
        <li>Lien: <strong>{{connectionLink}}</strong></li>
        <li>Commentaire: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-100003',
    language: Language.NL,
    subject: 'Herinnering: te ondertekenen document(en)',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte huurder,</p>
        <p></p>
        <p>Betreffende: herinnering aan de uitnodiging om document(en) in verband uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> te ondertekenen.</p>
        <p></p>
        <p>We nodigen u uit om de document(en) te ondertekenen door in te loggen op uw account:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Opmerking: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-100004',
    language: Language.DE,
    subject: 'Erinnerung: zu unterschreibende Dokument(e)',
    type: TemplateType.MAIL,
    subType: TemplateSubType.DOCUMENT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r Mieter/in,</p>
        <p></p>
        <p>Betreff: Erinnerung an die Einladung zur Unterzeichnung von Dokument(en) bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wir erinnern Sie freundlich daran, einige Dokument(e) zu unterzeichnen, indem Sie sich in Ihr Konto einloggen:</p>
        <ul>
        <li>Link: <strong>{{connectionLink}}</strong></li>
        <li>Kommentar: <i>{{additionalMessage}}</i></li>
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
